<template>
  <Layout>
    <h1>diaigo accounting</h1>
  </Layout>
</template>

<script>
export default {
  name: "home"
};
</script>
